import { BoxProps, ButtonProps, ColorOptions } from '@jfs/ui-new'
import { Dimensions, ViewStyle } from 'react-native'
import { colors } from '../../util/colors'
import { isMobileWidth, isTabletWidth } from '../../util/util'

export const styles = (breakpoint: number, responsivePadding: number) => {
  const isMobile = isMobileWidth(breakpoint) //breakpoint < 520
  const isTab = isTabletWidth(breakpoint) //breakpoint < 992
  // const responsivePadding = getPadding(breakpoint)
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      zIndex: 1,
      overflow: 'scroll',
      h: 'calc(100vh - 72px)',
      position: 'relative',
      bg: 'WHITE',
      borderTopWidth: 1,
      borderTopColor: '#0000001F' as ColorOptions,
    } as BoxProps,
    gradientBackground: {
      position: 'absolute',
      width: '100%',
      // height:
      zIndex: -2,
      backgroundColor: '#24397A' as ColorOptions,
    } as BoxProps,
    content: {
      display: 'flex',
      flexDirection: isTab ? 'row' : isMobile ? 'column-reverse' : 'row',
      paddingHorizontal: responsivePadding,
      paddingTop: isTab || isMobile ? 0 : 60,
      paddingBottom: isTab || isMobile ? 0 : 30 + 120,
    } as BoxProps,
    borderTopRadius: {
      borderTopRightRadius: isMobile ? 50 : 100,
      borderTopLeftRadius: isMobile ? 50 : 100,
    } as BoxProps,
    boxLanding: {
      display: 'flex',
      minWidth: isMobile || isTab ? undefined : 400,
      flexDirection: 'column',
      justifyContent: isTab ? 'center' : 'flex-start',
      alignContent: 'center',
      alignSelf: isMobile || isTab ? 'center' : undefined,
      // minHeight: isMobile ? '70vh' : '90vh',
      width: isMobile ? '100%' : isTab ? '55%' : breakpoint === 1024 ? '65%' : '60%',
      zIndex: 12,
      marginTop: isMobile ? 28 : isTab ? 100 : 94,
    } as BoxProps,
    button: {
      borderRadius: 8,
      width: isMobile || isTab ? 144 : 192,
      height: isMobile || isTab ? 48 : 56,
      color: colors.HIGHLIGHT as ColorOptions,
    } as ButtonProps,
    signup: {
      type: 'primary',
      color: 'BLUE_SHADE_PRIMARY',
    } as ButtonProps,
    imageBox: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      minWidth: isMobile ? undefined : 400,
      marginLeft: isMobile ? -12 : undefined,
      minHeight: isTab
        ? breakpoint === 1024
          ? '40vh'
          : '60vh'
        : isMobile
        ? Dimensions.get('window').width * 0.75
        : '50vh',
    } as BoxProps,
    imageBoxFix: {
      paddingLeft: isTab ? 100 : undefined,
      // marginRight: isTab ? 0 : '-16%',
      marginTop: isTab ? 0 : isMobile ? 8 : 10,
    } as BoxProps,
    buttonBox: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      flexWrap: 'wrap',
      minHeight: !isMobile ? 120 : undefined,
      marginTop: 24,
    } as BoxProps,
    layoutBackground: {
      display: 'flex',
      paddingTop: isMobile ? 100 : 0,
      paddingBottom: 0,
    } as BoxProps,
    imageLandingPage: {
      width: '100%',
      minHeight: 421,
    } as ViewStyle,
    ImageKeyborad: {
      width: 24,
      height: 24,
      marginTop: 5,
    } as ViewStyle,
    imageDottedSize: {
      width: 260,
      height: 260,
    } as ViewStyle,
    dimRightArrow: {
      width: 20,
      height: 20,
      opacity: 0.2,
      marginTop: 3,
    } as ViewStyle,
    footerBackground: {
      paddingTop: 40,
      // borderTopLeftRadius: 120,
      // borderTopRightRadius: 120,
      marginTop: -90,
      boxShadow: '0px 4px 4px #00000029' as ColorOptions,
      bg: 'WHITE',
    } as BoxProps,
    titleContainer: {
      width: isMobile ? '85%' : isTab ? '80%' : '60%',
    } as BoxProps,
  }
}
